import * as yup from 'yup';
import { regexAcronymState, regexFiscalCode } from 'system/geographic/components/state/constants';
import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { MunicipalityClient } from './types';
import { regexOnlyNumber } from 'shell/constants/regex';

export const validationSchemaMunicipalityFilter = yup.object({
  code: yup.string().matches(regexOnlyNumber, 'Il campo deve essere un numero'),
  name: yup.string().max(40, 'Il campo nome non può superare i 40 caratteri'),
  istatCode: yup.string().matches(regexOnlyNumber, 'Il campo deve essere un numero'),
  provinceCode: yup
    .string()
    .min(1, 'Il campo codice provincia deve essere almeno di 1 caratteri')
    .max(3, 'Il campo codice provincia deve essere al massimo di 3 caratteri')
    .matches(regexAcronymState, 'Il campo codice provincia deve essere es: c oppure ci oppure ci*'),
  fiscalCode: yup.string().matches(regexFiscalCode, 'Il campo deve essere es: M123'),
});

export const headCells: HeadCell<MunicipalityClient, keyof MunicipalityClient>[] = [
  {
    id: 'code',
    label: 'Codice comune',
  },
  {
    id: 'istatCode',
    label: 'Codice ISTAT',
  },
  {
    id: 'name',
    label: 'Nome comune',
  },
  {
    id: 'location',
    label: 'Provincia / Stato estero',
  },
  {
    id: 'consulate',
    label: 'Consolato',
  },
  {
    id: 'institutionDate',
    label: 'Data istituzione',
  },
  {
    id: 'state',
    label: 'Stato comune',
  },
  {
    id: 'endDate',
    label: 'Data cessazione',
  },
  {
    id: 'action',
    label: 'Azioni',
    disabled: true,
  },
];

export const authsMunicipality = Object.freeze({
  read: [SystemAuthorizations.ComuneQuery],
  create: [SystemAuthorizations.ComuneAdd],
  edit: [SystemAuthorizations.ComuneUpdate],
  delete: [SystemAuthorizations.ComuneDelete],
});
